import { Building2, Shirt, Sparkles } from "lucide-react";

export const MODULES = {
  conciergerie: { label: "Conciergerie", color: "#B45309", badge: "bg-amber-50 text-amber-700", dot: "bg-amber-500", icon: Building2 },
  laundry: { label: "Blanchisserie", color: "#0369A1", badge: "bg-sky-50 text-sky-700", dot: "bg-sky-500", icon: Shirt },
  nettoyage: { label: "Nettoyage", color: "#047857", badge: "bg-emerald-50 text-emerald-700", dot: "bg-emerald-500", icon: Sparkles },
};

export const ORDER_STATUS = {
  planifie: { label: "Planifié", cls: "bg-slate-100 text-slate-600" },
  en_cours: { label: "En cours", cls: "bg-blue-50 text-blue-700" },
  realise: { label: "Réalisé", cls: "bg-amber-50 text-amber-700" },
  facture: { label: "Facturé", cls: "bg-emerald-50 text-emerald-700" },
};

export const INVOICE_STATUS = {
  emise: { label: "En attente", cls: "bg-amber-50 text-amber-700" },
  payee: { label: "Payée", cls: "bg-emerald-50 text-emerald-700" },
  annulee: { label: "Annulée", cls: "bg-slate-100 text-slate-500" },
};

export const fmtCHF = (n) =>
  `CHF ${(n ?? 0).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = (d) => {
  if (!d) return "—";
  const m = String(d).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) return `${m[3]}.${m[2]}.${m[1]}`;
  const dt = new Date(d);
  return `${String(dt.getDate()).padStart(2, "0")}.${String(dt.getMonth() + 1).padStart(2, "0")}.${dt.getFullYear()}`;
};
export const fmtDateTime = (d) => {
  if (!d) return "—";
  const dt = new Date(d);
  return `${fmtDate(d)} ${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`;
};

export const ORDER_TYPE = {
  refacturation: { label: "Refacturation", cls: "bg-violet-50 text-violet-700" },
};

export const orderSummary = (o) => {
  if (o.order_type === "refacturation") return o.ref_label || o.description || "Refacturation";
  const d = o.details || {};
  const arts = d.articles || [];
  if (arts.length) return arts.slice(0, 3).map((a) => `${a.qty} ${a.name}`).join(", ");
  if (o.module === "laundry") return `${d.weight_kg ?? 0} kg`;
  if (o.module === "nettoyage") return `${d.hours ?? 0} h`;
  return d.mission_type || "Forfait";
};

export const UNITS = { piece: "à la pièce", kg: "au kg", heure: "à l'heure", forfait: "forfait" };
export const unitShort = (u) => ({ piece: "pièce", kg: "kg", heure: "h", forfait: "forfait" }[u] || u);

export const clientName = (c) => c?.name || `${c?.first_name || ""} ${c?.last_name || ""}`.trim() || "—";
export const clientAddress = (c) => c?.address || [c?.street, `${c?.zip || ""} ${c?.city || ""}`.trim(), c?.country].filter(Boolean).join(", ");

export const ORIGINES = {
  saphir_immo: { label: "Saphir Immo SA", cls: "bg-indigo-50 text-indigo-700" },
  service_location: { label: "Service Location", cls: "bg-rose-50 text-rose-700" },
};
